import {
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Spin,
  Switch,
  Tag,
  Dropdown,
  Menu,
  TreeSelect,
  TreeSelectProps,
  Popover,
  Space,
  Row,
  Col,
  Card,
  Statistic,
} from "antd";
import axios from "axios";
import { debounce } from "lodash";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import ProductDetails from "./details/ProductDetails";
import { authenticateToken } from "../../utils/auth";
import {
  getImgUrl,
  getParamValue,
  jcTypeArray,
  getUpdatedUrl,
  checkStatesAndPushToHistory,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { DefaultOptionType } from "antd/lib/select";
import TopHeading, { ProductCreateProps } from "./TopHeading";
import { useHistory, useLocation } from "react-router";
import Empty from "../common/Empty";
import { responseNotification } from "../../utils/notify";
import {
  BarcodeOutlined,
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  ShopOutlined,
  FileImageOutlined,
  BugOutlined,
  DislikeOutlined,
  LikeOutlined,
  FundOutlined,
  UnorderedListOutlined,
  StopOutlined,
} from "@ant-design/icons";
import AddProduct from "./AddProduct";
import { Link } from "react-router-dom";
import usePrevious from "../../hooks/PreviousState";

const { Option } = Select;

const ProductList = ({
  inCampaignId,
}: {
  inCampaignId?: string;
}): ReactElement => {
  const router = useLocation();
  const history = useHistory();
  const [limit, setLimit] = useState(20);
  const [type, setType] = useState(
    getParamValue(router.search, "type") || "JC_MART"
  );
  const [categoryId, setCategoryId] = useState<any>();
  const [selectedProductId, setSelectedProductId] = useState(undefined);
  const [campaignId, setCampaignId] = useState<any>(inCampaignId);
  const [productData, setProductData] = useState<any>({
    loading: false,
    item: [],
  });
  const [suppliersOptions, setSuppliersOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [selectedProductForEdit, setSelectedProductForEdit] =
    useState(undefined);
  const [status, setStatus] = useState("");
  const [key, setKey] = useState(getParamValue(router.search, "key"));
  const [barCode, setBarCode] = useState(
    getParamValue(router.search, "barCode")
  );
  const [isActive, setIsActive] = useState(
    getParamValue(router.search, "isActive")
  );

  const [productBarcodeOptions, setProductBarcodeOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [campaignOptions, setCampaignOptions] = useState({
    loading: false,
    list: [],
  });

  const [productOptions, setProductOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [treeData, setTreeData] = useState<Omit<DefaultOptionType, "label">[]>(
    []
  );
  const [parentCatOptions, setParentCatOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [supplierId, setSupplierId] = useState(
    getParamValue(router.search, "supplierId")
  );
  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [brandId, setBrandId] = useState<any>();
  const [hubsOptions, setHubsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [hubId, setHubId] = useState(getParamValue(router.search, "hubId"));
  const [shopId, setShopId] = useState(getParamValue(router.search, "shopId"));

  const page = getParamValue(router?.search, "page") || 0;

  const [form] = Form.useForm();

  const prevType = usePrevious(type);
  const prevHubId = usePrevious(hubId);
  const prevShopId = usePrevious(shopId);
  const prevSupplierId = usePrevious(supplierId);
  const prevIsActive = usePrevious(isActive);
  const prevBarCode = usePrevious(barCode);
  const prevKey = usePrevious(key);

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };

  const fetchProducts = useCallback(() => {
    try {
      setProductData({ loading: true, item: [] });
      let shouldResetPage = false;
      if (localStorage.getItem("rememberProductsFilter") != null) {
        checkLocalStorageAndSetParams();
        localStorage.removeItem("rememberProductsFilter");
      } else {
        shouldResetPage = checkStatesAndPushToHistory(
          [
            prevType,
            prevHubId,
            prevShopId,
            prevSupplierId,
            prevBarCode,
            prevKey,
            prevIsActive,
          ],
          [type, hubId, shopId, supplierId, barCode, key, isActive],
          [
            "type",
            "hubId",
            "shopId",
            "supplierId",
            "barCode",
            "key",
            "isActive",
          ],
          history
        );
      }

      const url =
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/product/v2?` +
        `page=${shouldResetPage ? 0 : page || 0}` +
        `&limit=${limit || 16}` +
        `&isDeleted=${false}` +
        (barCode ? `&barCode=${barCode}` : ``) +
        (key ? `&key=${key}` : ``) +
        (brandId ? `&brandId=${brandId}` : ``) +
        (type ? `&type=${type}` : ``) +
        (hubId ? `&hubId=${hubId}` : ``) +
        (shopId ? `&shopId=${shopId}` : ``) +
        (supplierId ? `&supplierId=${supplierId}` : ``) +
        (categoryId ? `&categoryId=${categoryId}` : ``) +
        (campaignId ? `&campaignId=${campaignId}` : ``) +
        (isActive ? `&isActive=${isActive}` : ``);

      fetch(url, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setProductData({ loading: false, item: data });
        })
        .catch(() => {
          setProductData({ loading: true, item: [] });
        });
    } catch (error) {
      setProductData({ loading: true, item: [] });
      console.log(error, "error");
    }
  }, [
    limit,
    page,
    status,
    brandId,
    hubId,
    shopId,
    supplierId,
    key,
    barCode,
    type,
    categoryId,
    campaignId,
    isActive,
  ]);

  const getCampaignOptions = useCallback(async (key?: string) => {
    setCampaignOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    const res = await axios.get(
      `${encodedUri}/admin/campaign/all?type=${type}` +
        (key ? `&key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );

    setCampaignOptions({
      loading: false,
      list: res?.data?.campaigns?.map((campaign: any) => ({
        label: campaign.name,
        value: campaign.id,
      })),
    });
  }, []);

  const getProductByBarcodeOptions = useCallback(
    async (bCode) => {
      setProductBarcodeOptions({ loading: false, list: [] });

      setProductBarcodeOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?` +
          `page=${page || 0}` +
          `&limit=${limit || 16}` +
          `&isDeleted=${false}` +
          (bCode ? `&barCode=${bCode}` : ``) +
          (key ? `&key=${key}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive !== "" ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductBarcodeOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any; barCode: any }) => {
          return {
            value: product?.barCode,
            label: product?.name,
          };
        }),
      });
    },
    [page, limit, key, type, isActive, status]
  );

  const getProductOptions = useCallback(
    async (val) => {
      setProductOptions({ loading: false, list: [] });

      setProductOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?` +
          `page=${page || 0}` +
          `&limit=${limit || 16}` +
          `&isDeleted=${false}` +
          (val ? `&key=${val}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive !== "" ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any }) => {
          return {
            value: product?.name,
            label: product?.name,
          };
        }),
      });
    },
    [page, limit, barCode, type, isActive, status]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  const getHubsOptions = useCallback(
    async (val?: string) => {
      setHubsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/hub/all?page=0&limit=20` +
          (val ? `&name=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setHubsOptions({
        loading: false,
        list: res?.data?.hubs?.map((hub) => {
          return {
            value: hub?.id,
            label: hub?.name,
          };
        }),
      });
    },
    [type]
  );

  const genTreeNode = (parentId: number, category: any) => {
    return {
      ...category,
      id: category?.id,
      pId: parentId,
      value: category?.id,
      title: category?.title,
      isLeaf: false,
    };
  };
  const getParentCategory = useCallback(async (val: string) => {
    const res = await axios.get(
      `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/parent-by-type?type=${type}&page=0&limit=50` +
        (val ? `&key=${val}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );
    setTreeData(
      res.data?.categories?.map(
        (category: Omit<DefaultOptionType, "label">) => ({
          ...category,
          id: category?.id,
          pId: 0,
          title: category?.title,
          value: category?.id,
          isLeaf: false,
        })
      )
    );
  }, []);

  const onLoadData: TreeSelectProps["loadData"] = ({ id }) => {
    return new Promise((resolve) => {
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      axios
        .get(
          `${encodedUri}/admin/category/child-category-by-parent?categoryId=${id}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          if (data.status === 200) {
            // ****************************
            setTimeout(() => {
              setTreeData(
                treeData?.concat(
                  data?.data?.categories?.map(
                    (category: Omit<DefaultOptionType, "label">) =>
                      genTreeNode(id, category)
                  )
                )
              );
              resolve(undefined);
            }, 300);
            // ****************************
          } else {
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };
  const onChange = (newValue: string) => {
    setCategoryId(newValue);
  };

  const filteredCategory = treeData.find((category) => {
    return category?.id === categoryId;
  });
  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/shop/admin/search?page=0&limit=20` +
          (val ? `&key=${val}` : ``) +
          (hubId ? `&hubId=${hubId}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            id: shop?.id,
            name: shop?.name,
          };
        }),
      });
    },
    [type, hubId]
  );

  const getSupplierOptions = useCallback(
    async (val?: string) => {
      setSuppliersOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/supplier/by-shop` +
          (shopId ? `?shopId=${shopId}` : ``) +
          (val ? `&key=${val}` : ``) +
          (page ? `&page=${page}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setSuppliersOptions({
        loading: false,
        list: res?.data?.suppliers?.map((supplier) => {
          return {
            value: supplier?.id,
            label: supplier?.name,
          };
        }),
      });
    },
    [type, shopId]
  );

  const fetchRef = useRef(null);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "product") getProductOptions(value);
          else if (field === "productByBarcode")
            getProductByBarcodeOptions(value);
          else if (field === "brand") getBrandsOptions(value);
          else if (field === "campaign") getCampaignOptions(value);
          else if (field === "hub") getHubsOptions(value);
          else if (field === "shop") getShopsOptions(value);
          else if (field === "supplier") getSupplierOptions(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getBrandsOptions,
    getProductOptions,
    getProductByBarcodeOptions,
    getHubsOptions,
    getShopsOptions,
    getCampaignOptions,
    getSupplierOptions,
    type,
  ]);

  //
  const onStatusChange = async (id, val) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/product`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          // deleted: !val,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            fetchProducts();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  // useEffect(() => {
  //   setShopsOptions({ list: [], loading: false });
  //   setBrandId("");
  //   setIsActive("");
  //   setBrandsOptions({ list: [], loading: false });
  //   setparentCategoryId(queryParams.get("parentCategoryId"));
  //   setchildCategoryId(queryParams.get("childCategoryId"));
  //   setBarCode(queryParams.get("barCode"));
  //   setKey(queryParams.get("key"));
  //   setHubId(queryParams.get("hubId"));
  //   setShopId(queryParams.get("shopId"));
  //   setCategoriesOptions({ list: [], loading: false });
  //   setIsActive(queryParams.get("isActive"));
  //   form.resetFields([
  //     "barcode_search",
  //     "product_search",
  //     "category_search",
  //     "brand_search",
  //     "shop_search",
  //     "hub_search",
  //     "deleted_search",
  //   ]);
  // }, [form, type]);

  useEffect(() => {
    if (inCampaignId) {
      setCampaignId(inCampaignId);
    }
    fetchProducts();
  }, [fetchProducts, inCampaignId]);

  useEffect(() => {
    if (type) {
      getBrandsOptions();
      getHubsOptions();
      getShopsOptions();
      getParentCategory("");
      getCampaignOptions();
      getSupplierOptions();
    }
  }, [
    getBrandsOptions,
    getHubsOptions,
    getShopsOptions,
    getParentCategory,
    getCampaignOptions,
    getSupplierOptions,
    type,
  ]);
  useEffect(() => {
    if (shopId) {
      getSupplierOptions();
    }
  }, [getSupplierOptions, shopId]);

  const createProps = {
    total: productData?.item?.totalElements,
    categoriesOptions,
    shopsOptions,
    brandsOptions,
    refetch: fetchProducts,
    setType,
    handleSearch,
    type,
  } as ProductCreateProps;

  const onClose = () => {
    setSelectedProductId(null);
    setSelectedProductForEdit(undefined);
    fetchProducts();
  };

  const resetAllFieldData = () => {
    setKey("");
    setBarCode("");
    setType("");
    setHubId("");
    setShopId("");
    setBrandId("");
    setIsActive("");
    form.resetFields();
    history.replace(router.pathname);
    window.location.reload();
  };
  const style: React.CSSProperties = {
    background: "#727273",
    borderRadius: "5px",
    textAlign: "center",
    padding: "8px 0",
    marginBottom: "10px",
  };
  function getShopName() {
    shopsOptions?.forEach((shop) => {
      // console.log("shopName: ", shop?.name);
      if (shop?.id == shopId) return shop?.name;
    });
    return "";
  }

  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberProductsFilter")
    );
    // console.log("rememberProductsFilter: ", retrievedObject);
    if (retrievedObject.type) setType(retrievedObject.type);
    if (retrievedObject.barCode) setBarCode(retrievedObject.barCode);
    if (retrievedObject.key) setKey(retrievedObject.key);
    if (retrievedObject.hubId) setHubId(retrievedObject.hubId);
    if (retrievedObject.shopId) setShopId(retrievedObject.shopId);
    if (retrievedObject.isActive) setIsActive(retrievedObject.isActive);
    if (retrievedObject.page) {
      history.push(getUpdatedUrl("page", `${retrievedObject.page}`));
    }
  }
  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberProductsFilter",
      JSON.stringify({
        type: type,
        barCode: barCode,
        key: key,
        hubId: hubId,
        shopId: shopId,
        isActive: isActive,
        page: page,
      })
    );
  };

  const goToProductEdit = (value) => {
    saveCurrentStatesInLocalStorage();
    history.push(`/products/${value}/edit`);
  };

  return (
    <div className="product-lists">
      <TopHeading {...createProps} />
      {/* <section>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={3}>
            <div style={style}>
              <Statistic
                title="Total Product"
                value={productData.item?.totalElements  || 0}
                prefix={<UnorderedListOutlined />}
              />
            </div>
          </Col>
          <Col className="gutter-row" span={3}>
            <div style={style}>
              <Statistic title="Pending" value={10} prefix={<FundOutlined />} />
            </div>
          </Col>
          <Col className="gutter-row" span={3}>
            <div style={style}>
              <Statistic title="Active" value={10} prefix={<LikeOutlined />} />
            </div>
          </Col>
          <Col className="gutter-row" span={3}>
            <div style={style}>
              <Statistic
                title="Deactive"
                value={10}
                prefix={<DislikeOutlined />}
              />
            </div>
          </Col>
          <Col className="gutter-row" span={3}>
            <div style={style}>
              <Statistic
                title="Stock Out"
                value={10}
                prefix={<StopOutlined />}
              />
            </div>
          </Col>
          <Col className="gutter-row" span={3}>
            <div style={style}>
              <Statistic
                title="SEO Missing"
                value={10}
                prefix={<BugOutlined />}
              />
            </div>
          </Col>
          <Col className="gutter-row" span={3}>
            <div style={style}>
              <Statistic
                title="Image Missing"
                value={10}
                prefix={<FileImageOutlined />}
              />
            </div>
          </Col>
        </Row>
      </section> */}

      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="type_search" initialValue={type}>
            <Select
              showSearch
              placeholder="Filter by Type"
              onChange={(val) => setType(val as string)}
            >
              <Select.Option value="">ALL TYPES</Select.Option>
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type.replace("_", " ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="barcode_search" initialValue={barCode}>
            <AutoComplete
              onSearch={(e) => handleSearch(e, "productByBarcode")}
              onSelect={(val) => setBarCode(val)}
              options={productBarcodeOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                productBarcodeOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                size="large"
                placeholder="Search by BarCode"
                onSearch={(val) => {
                  setBarCode(val);
                }}
                enterButton
                loading={productBarcodeOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>

          <Form.Item name="product_search" initialValue={key}>
            <AutoComplete
              onSearch={(e) => handleSearch(e, "product")}
              onSelect={(val) => setKey(val.toString())}
              options={productOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                productOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                size="large"
                placeholder="Search by Name"
                onSearch={(val) => {
                  setKey(val);
                }}
                enterButton
                loading={productOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>

          <Form.Item name="hub_search" initialValue={hubId}>
            <Select
              allowClear
              showSearch
              // defaultValue={getHubName}
              placeholder="Filter by Hub"
              optionFilterProp="children"
              onChange={(val) => setHubId(val)}
              onSearch={(e) => handleSearch(e, "hub")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {hubsOptions.list.length ? (
                <Option value={""}>All Hub</Option>
              ) : undefined}
              {hubsOptions?.list?.map((hub) => (
                <Option value={hub?.value}>{hub?.label}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="shop_search" initialValue={shopId}>
            <Select
              allowClear
              showSearch
              defaultValue={getShopName}
              placeholder="Filter by Shop"
              optionFilterProp="children"
              onChange={(val) => setShopId(val)}
              onSearch={(e) => handleSearch(e, "shop")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {shopsOptions.list.length ? (
                <Option value={""}>All Shop</Option>
              ) : undefined}
              {shopsOptions?.list?.map((shop) => (
                <Option value={shop?.id}>{shop?.name}</Option>
              ))}
            </Select>
          </Form.Item>
          {shopId && (
            <Form.Item name="supplier_search">
              <Select
                allowClear
                autoClearSearchValue
                showSearch
                placeholder="Filter by Supplier"
                optionFilterProp="children"
                onChange={(val) => setSupplierId(val)}
                onSearch={(e) => handleSearch(e, "supplier")}
                filterOption={(input, option) =>
                  option.children
                    .toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {suppliersOptions?.list?.map((supplier) => (
                  <Option value={supplier.value}>{supplier.label}</Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item name="category_search">
            <TreeSelect
              allowClear
              treeDataSimpleMode
              style={{ width: "100%" }}
              value={categoryId}
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="Filter by Category"
              onChange={onChange}
              loadData={onLoadData}
              treeData={treeData}
            />
          </Form.Item>
          <Form.Item name="brand_search">
            <Select
              showSearch
              placeholder="Filter by Brand"
              optionFilterProp="children"
              onChange={(val) => setBrandId(val)}
              onSearch={(e) => handleSearch(e, "brand")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {brandsOptions.list.length ? (
                <Option value={""}>All Brands</Option>
              ) : undefined}{" "}
              {brandsOptions.list.map((brand) => (
                <Option value={brand.id}>{brand.name}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="campaign_search">
            <Select
              allowClear
              showSearch
              placeholder="Filter by Campaign"
              optionFilterProp="children"
              onChange={(val) => setCampaignId(val)}
              onSearch={(e) => handleSearch(e, "campaign")}
              filterOption={() => {
                return true;
              }}
              options={campaignOptions?.list}
            ></Select>
          </Form.Item>

          <Form.Item
            name="deleted_search"
            initialValue={
              isActive == "true"
                ? "ACTIVE"
                : isActive == "false"
                ? "INACTIVE"
                : "ALL"
            }
          >
            <Select
              showSearch
              placeholder="Status"
              onChange={(val) => setIsActive(val as string)}
            >
              <Select.Option value={""}>ALL</Select.Option>
              <Select.Option value={"true"} title="ACTIVE">
                ACTIVE
              </Select.Option>
              <Select.Option value={"false"} title="INACTIVE">
                INACTIVE
              </Select.Option>
            </Select>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button
            type="primary"
            size="large"
            danger
            onClick={resetAllFieldData}
          >
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading major">
                    <span>Product Name</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Vendor</span>
                  </div>
                  <div className="single-product-heading major">
                    <span>Stock & Price</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {productData.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {productData.item?.products?.length ? (
                    productData?.item?.products?.map(
                      (product: any, index: number) => (
                        <React.Fragment key={index}>
                          <Link
                            onClick={saveCurrentStatesInLocalStorage}
                            to={`/products/${product?.slug}/details`}
                          >
                            <div className="single-product-wrapper">
                              <div className="single-product major">
                                <Avatar
                                  shape="square"
                                  size={50}
                                  src={getImgUrl(product?.productImage)}
                                  className="mr-3"
                                />
                                <span className="name">{product?.name}</span>
                              </div>
                              <div className="single-product">
                                <ShopOutlined />
                                <span className="name ml-1 text-uppercase">
                                  {product?.shop?.name}
                                </span>
                              </div>
                              <div className="single-product major">
                                <div className="d-flex_">
                                  {product?.variations?.length
                                    ? product?.variations?.map(
                                        (variant, index) => (
                                          <React.Fragment key={index}>
                                            <div className="d-flex justify-content-start mb-1">
                                              {variant?.barCode ? (
                                                <Tag className="d-flex align-items-center">
                                                  <BarcodeOutlined className="mr-1" />{" "}
                                                  {variant?.barCode}
                                                </Tag>
                                              ) : product?.barCode ? (
                                                <Tag className="d-flex align-items-center">
                                                  <BarcodeOutlined className="mr-1" />{" "}
                                                  {product?.barCode}
                                                </Tag>
                                              ) : undefined}
                                              <Tag
                                                color={
                                                  variant?.stock < 10
                                                    ? `red`
                                                    : `green`
                                                }
                                              >
                                                {variant?.variationName?.toUpperCase()}
                                                : <b>{variant?.stock || 0}</b>
                                              </Tag>
                                            </div>
                                            <div className="d-flex  justify-content-start mb-1">
                                              <Tag>
                                                MRP{" "}
                                                {variant?.price?.currencyCode}
                                                {variant?.price
                                                  ?.discountedPrice ||
                                                  variant?.price?.mrp}
                                                {variant?.price
                                                  ?.discountedPrice &&
                                                  variant?.price
                                                    ?.discountedPrice !==
                                                    variant?.price?.mrp && (
                                                    <span className="text-danger">
                                                      {" "}
                                                      <del>
                                                        {variant?.price
                                                          ?.currencyCode ||
                                                          "Tk"}
                                                        {variant?.price?.mrp}
                                                      </del>
                                                    </span>
                                                  )}
                                              </Tag>
                                              <Tag>
                                                TP {variant?.price?.tp}{" "}
                                                {variant?.price?.currencyCode}
                                              </Tag>
                                            </div>
                                          </React.Fragment>
                                        )
                                      )
                                    : undefined}
                                </div>
                              </div>

                              {/* <div className="single-product">
                                <span className="name d-flex-l">
                                  {product?.numberOfRating ? (
                                    <Rate
                                      value={product?.rating || 0}
                                      disabled
                                    />
                                  ) : (
                                    <Rate value={0} disabled />
                                  )}
                                  {product?.numberOfRating > 0 ? (
                                    <small className="ml-1">
                                      ({product?.numberOfRating})
                                    </small>
                                  ) : undefined}
                                </span>
                              </div> */}

                              <div className="single-product">
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  defaultChecked={product?.isActive}
                                  onChange={(val, e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onStatusChange(product?.id, val);
                                  }}
                                  disabled={
                                    product?.supplier?.deleted ||
                                    product?.shop?.deleted ||
                                    product?.hub?.deleted
                                  }
                                  size="default"
                                />
                              </div>

                              <div className="single-product">
                                <Dropdown.Button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    // history.push(
                                    //   `/products/${product?.slug}/edit`
                                    // );
                                    goToProductEdit(product?.slug);
                                  }}
                                  overlay={
                                    <Menu>
                                      <Menu.Item key="1">
                                        <Link
                                          to={`/products/${product?.slug}/edit`}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                          }}
                                        >
                                          Single Edit
                                        </Link>
                                      </Menu.Item>
                                      <Menu.Item key="2">
                                        <Link
                                          to={`/products/${product?.slug}/edit=multiple-shop`}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                          }}
                                        >
                                          Multi Shop
                                        </Link>
                                      </Menu.Item>
                                    </Menu>
                                  }
                                >
                                  <EditOutlined />
                                </Dropdown.Button>
                              </div>
                            </div>
                          </Link>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Products" />
                  )}
                  <Drawer
                    title={
                      selectedProductForEdit
                        ? "Edit Product"
                        : "Product Details"
                    }
                    width={1050}
                    onClose={onClose}
                    visible={selectedProductId || selectedProductForEdit}
                    bodyStyle={{ paddingBottom: 80 }}
                    footer={
                      <div
                        style={{
                          textAlign: "right",
                        }}
                      ></div>
                    }
                  >
                    {selectedProductForEdit ? (
                      <AddProduct
                        productSlug={selectedProductForEdit}
                        onCloseMethod={onClose}
                        {...createProps}
                      />
                    ) : (
                      <ProductDetails selectedProductId={selectedProductId} />
                    )}
                  </Drawer>
                </div>
              </div>
            )}
          </div>
          <PaginationTwo
            {...productData.item}
            limit={limit}
            page={productData?.item?.currentPageNumber || 0}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductList;
